import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_licenseplate_by_licenseplateId_top1Service {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { licenseplateId: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Location?: { Name?: string } } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.licenseplateId)) {
      $missingRequiredInParams.push('\'licenseplateId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      licenseplateId: number    }) {
        if(isNil($inParams.licenseplateId)) {
          return true; 
        }
      return false;
    }
}
